
import { defineComponent } from "vue";
import { useSidebar } from "./utils";

export default defineComponent({
  name: "SidebarRail",
  setup() {
    const { toggleSidebar } = useSidebar();

    return { toggleSidebar };
  },
});
